/**
 * shared shadow DOM styles
 */

// import { css } from 'lit-element';
import theme from './theme-variables.scss';

export const sharedStyles = theme;
export const PERSONAL_RECIPE_ICON_BG_CLASS = 'dd-circle-icon-fade';
